<div class="check-session-page">
    <div class="check-session-spinner" role="status" aria-label="Loading">
        <span class="spinner-ring"></span>
        <span class="spinner-ring"></span>
        <span class="spinner-ring"></span>
    </div>
</div>
